import { useMemo } from 'react';
import { z } from 'zod';
import { useEmirateField } from '../../../members/members-form/fields';
import { IMembersForm } from '../types';

export const useCommonFieldsStructure = () => {
	const emirateField = useEmirateField<IMembersForm>();
	const fieldsStructure = useMemo(() => [emirateField.getField({ field: 'emirateId' })], [emirateField.getField]);

	const getValidations = () => z.object({}).merge(emirateField.getValidation());

	return {
		fieldsStructure,
		getValidations,
	};
};
